var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6004 9V7C15.6004 6.46957 15.4108 5.96086 15.0732 5.58579C14.7356 5.21071 14.2778 5 13.8004 5H10.2004C9.723 5 9.26516 5.21071 8.9276 5.58579C8.59003 5.96086 8.40039 6.46957 8.40039 7V8C8.40039 8.31049 8.46545 8.61672 8.59043 8.89443C8.71539 9.17214 8.89684 9.41371 9.12039 9.6L14.8804 14.4C15.104 14.5863 15.2854 14.8279 15.4104 15.1056C15.5353 15.3833 15.6004 15.6895 15.6004 16V17C15.6004 17.5304 15.4108 18.0391 15.0732 18.4142C14.7356 18.7893 14.2778 19 13.8004 19H10.2004C9.723 19 9.26516 18.7893 8.9276 18.4142C8.59003 18.0391 8.40039 17.5304 8.40039 17V15",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3V21",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.a7ae1c012574894ce50111a3baabfe3f.svg";
export { ForwardRef as ReactComponent };